<template lang="pug">
  div
    v-bottom-sheet(v-if="showDialog" v-model="showDialog" persistent)
      v-card.round-top-xl
        v-card-title.px-4
          v-spacer
          .text-md.font-semibold.ml-n4 Apply offer
          v-spacer
          v-btn(icon color="neutral700" @click="closeDialog")
            v-icon mdi-close
        v-card-text.neutral700--text
          .text-sm.mb-4.font-semibold You are about to apply this offer to a customer.
          v-card.round-xl.pa-4.mb-3.card-border(outlined)
            redeem-offer-item-property(:title="offer.offer.name" :useBefore="offer.expired_at" :redeemableQuantity="offer.redeemable_qty")
          simple-profile(:name="profile.name" :phone="profile.phone")
        v-card-actions
          v-btn.button-md.white--text(block depressed :loading="isLoading" color="neutral700" @click="handleApplyOffer") Apply offer
    .dialogs
      offer-applied-dialog(v-if="offerApplied.open" :open.sync="offerApplied.open" :customer="{ name: profile.name, phone: profile.phone }" :selectedOffer="offer" @backToHomepage="handleBackToHomepage")
</template>

<script>
import RedeemOfferItemProperty from "@/components/marketing/merchantapp/offer/RedeemOfferItemProperty.vue";
import SimpleProfile from "@/components/marketing/merchantapp/SimpleProfile.vue";
import {mapActions, mapGetters} from "vuex";
import OfferAppliedDialog from "@/components/marketing/merchantapp/dialogs/OfferAppliedDialog.vue";

export default {
  components: {
    OfferAppliedDialog,
    SimpleProfile,
    RedeemOfferItemProperty,
  },
  props: {
    open: {
      type: Boolean,
    },
    profile: {
      type: Object,
      required: true
    },
    offer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      offerCode: null,
      isLoading: false,
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
      },
      offerApplied: {
        open: false,
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    redeemOfferPayload() {
      return {
        coupon: this.offer.id,
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog() {
      this.showDialog = false
      this.$emit('close')
    },
    async handleApplyOffer() {
      const url = `/marketing/${this.company.slug}/redeems`
      try {
        this.isLoading = true
        const {data} = await this.$axios.post(url, this.redeemOfferPayload)
        this.updateActivityLog(url, this.redeemOfferPayload, data, 'POST', 'Redeem offer success', data.id)
        this.offerApplied.open = true
      } catch (error) {
        if (error.response.status === 400) {
          this.updateActivityLog(url, this.redeemOfferPayload, error.response.data, 'POST', 'Redeem offer invalid code')
          if (error.response.data?.detail.includes('Invalid code')) {
            this.showMessage(['error', 'Invalid code'])
          } else {
            this.showMessage(['error', error.response.data])
          }
        } else {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        }
      } finally {
        this.isLoading = false
      }
    },
    handleBackToHomepage() {
      this.$emit('backToHomepage')
      this.showDialog = false
    },
    updateActivityLog(endpoint, payload, response, method, activity, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'Redeem offer',
        activity: `Merchant-app: ${activity}`,
        raw_data: {endpoint, payload, response, method}
      }
      this.$axios.post('/users/logs', data)
          .catch(() => {
          })
    },
  },
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.error--text >>> fieldset {
  border-color: var(--v-danger);
}

.card-border {
  border: 1px solid #C1C1C1 !important;
}
</style>